import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import app from './modules/app'
import game from './modules/game'
import fight from './modules/fight'

const state = {
	
}

const store = new Vuex.Store({
	state,
	modules: {
		app,
		game,
		fight
	},
	strict: process.env.NODE_ENV !== 'production'
})

export default store